import React, { useEffect, FC } from 'react';
import { useRouteParams } from '@minecraft.utils';
import { APPLICATIONS } from '@blocs.auth';
import Loader from '@minecraft.loader';
import { LegacyRedirectRouteParams, LegacyRedirectTypes } from 'components/LegacyRedirect/LegacyRedirectTypes';
import redirectToApp from 'components/LegacyRedirect/utils/redirectToApp';
import { INVITATION_TYPES } from 'components/LegacyRedirect/constants';
import useGetIdByLegacyId from 'components/LegacyRedirect/hooks/useGetIdByLegacyId';

const LegacyRedirect: FC = () => {
  const { type, legacyInstance, legacyId, profileid, legacyUserName, legacyGroupId } = useRouteParams<
    Partial<LegacyRedirectRouteParams>
  >({
    parse: false,
  });
  const { data, errors } = useGetIdByLegacyId({
    type,
    legacyInstance,
    legacyUserName,
    legacyPresentationGroupId: legacyGroupId,
    legacyId: legacyId || profileid,
  });

  useEffect(() => {
    if (!data) return;

    const { legacyParams } = data;

    switch (type) {
      case LegacyRedirectTypes.ROLE:
        redirectToApp(APPLICATIONS.talent, `project/${legacyParams.projectId}/role/${legacyParams.id}`);
        break;
      case LegacyRedirectTypes.PROFILE:
        redirectToApp(APPLICATIONS.talent, `public-profile/${legacyParams.profileGuid}`);
        break;
      case LegacyRedirectTypes.PROJECT_TALENT:
        redirectToApp(APPLICATIONS.talent, `project/${legacyParams.id}`);
        break;
      case LegacyRedirectTypes.INVITATION:
        if (legacyParams.inviationType === INVITATION_TYPES.AUDITION) {
          redirectToApp(APPLICATIONS.talent, `audition-invite/${legacyParams.id}`);
        } else {
          redirectToApp(APPLICATIONS.talent, `callback-invite/${legacyParams.id}`);
        }

        break;
      case LegacyRedirectTypes.PROJECT:
        if (legacyParams.id) {
          redirectToApp(APPLICATIONS.reps, `projects/${legacyParams.id}`);
        } else {
          redirectToApp(APPLICATIONS.reps, `projects`);
        }

        break;
      case LegacyRedirectTypes.PACKAGE:
        redirectToApp(APPLICATIONS.reps, `${legacyParams.guid}`);
        break;
      case LegacyRedirectTypes.PRESENTATION:
        if (legacyParams.presentationGroupId && legacyParams.presentationFolderId && legacyGroupId) {
          redirectToApp(
            APPLICATIONS.casting,
            `${legacyParams.guid}/folder/${legacyParams.presentationFolderId}/group/${legacyParams.presentationGroupId}`
          );
        } else {
          redirectToApp(APPLICATIONS.casting, `${legacyParams.guid}`);
        }

        break;
      default:
        redirectToApp(APPLICATIONS.login, '', {
          clearLocalStorage: 'true',
        });
    }
  }, [data, legacyGroupId, type]);

  if (errors) {
    redirectToApp(APPLICATIONS.login);
  }

  return <Loader />;
};

export default LegacyRedirect;
